(() => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return;

  const sections = document.querySelectorAll(
    "#shopify-section-template--26956176523647__slideshow_UnfbaK, #shopify-section-template--26956176523647__slideshow_43DLGf, #shopify-section-template--26956176523647__slideshow_bXkDc9"
  );
  if (!sections.length) return;

  // Intensité générale (plus petit = moins de mouvement)
  const strength = 0.35;

  let raf = null;

  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

  const update = () => {
    raf = null;
    const vh = window.innerHeight || document.documentElement.clientHeight;

    sections.forEach((section) => {
      // ⚠️ IMPORTANT: on prend le conteneur image, pas seulement l'img
      const container = section.querySelector(".slide__image-container");
      const media = container?.querySelector("img, video");
      if (!container || !media) return;

      const rect = section.getBoundingClientRect();

      // Progress "doux" sur la traversée de l'écran
      // 0 quand la section est centrée, +/- quand elle s'éloigne
      const progress = (rect.top + rect.height / 2 - vh / 2) / vh;

      // Hauteur réelle du conteneur média
      const h = container.getBoundingClientRect().height || rect.height;

      // ✅ Déplacement max (en px). Ajuste si tu veux plus/moins de mouvement.
      // - borné pour éviter des valeurs trop fortes sur grandes sections
      const maxShift = clamp(h * 0.10, 18, 46); // 10% de la hauteur, min 18px, max 46px

      // Déplacement actuel
      const y = clamp(-progress * 280 * strength, -maxShift, maxShift);

      // ✅ Scale nécessaire pour couvrir le conteneur malgré le translate
      // Si on translate de maxShift vers le haut/bas, il faut "rab" = 2*maxShift
      const scale = 1 + (2 * maxShift) / h;

      media.style.transform = `translate3d(0, ${y}px, 0) scale(${scale.toFixed(4)})`;
      media.style.willChange = "transform";
    });
  };

  const onScroll = () => {
    if (raf) return;
    raf = requestAnimationFrame(update);
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  update();
})();
